module.exports = __webpack_public_path__ + "static/bel-748e31073a581be4b7d80176e04f556c.jpeg";